@keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
.atm_7l_ihld94{color:var(--animated-badge-text, var(--fabric-color-neutral-00));}
.atm_c8_v7fmpo.atm_c8_v7fmpo{font-size:var(--fabric-font-size-sm);}
.atm_cs_uepa5l.atm_cs_uepa5l{font-weight:var(--fabric-font-weight-regular);}
.atm_5j_1nyquae{border-radius:var(--fabric-radius-sm);}
.atm_e2_1tcgj5g{height:24px;}
.atm_vy_1ns9ob4{width:fit-content;}
.atm_l8_1s2714j{padding:0 1px;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_mk_h2mmj6{position:relative;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_bb_idpfg4.atm_bb_idpfg4{flex-shrink:0;}
.atm_1smt8mw_1yyfdc7::before,.atm_1smt8mw_1yyfdc7::after{content:'';}
.atm_11m2q5y_1ulexfb::before,.atm_11m2q5y_1ulexfb::after{display:block;}
.atm_juuh9p_stnw88::before,.atm_juuh9p_stnw88::after{position:absolute;}
.atm_1qhcasf_1ssbidh::before,.atm_1qhcasf_1ssbidh::after{top:50%;}
.atm_1bya9jv_1ssbidh::before,.atm_1bya9jv_1ssbidh::after{left:50%;}
.atm_1r5jvjd_15obr2h::before,.atm_1r5jvjd_15obr2h::after{width:200%;}
.atm_qguyfe_15obr2h::before,.atm_qguyfe_15obr2h::after{height:200%;}
.atm_w52pfw_1nyquae::before,.atm_w52pfw_1nyquae::after{border-radius:var(--fabric-radius-sm);}
.atm_1661vr5_174ut2m.atm_1661vr5_174ut2m::before,.atm_1661vr5_174ut2m.atm_1661vr5_174ut2m::after{background-size:100% 100%;}
.atm_dcvu3t_rpwrpy.atm_dcvu3t_rpwrpy::before,.atm_dcvu3t_rpwrpy.atm_dcvu3t_rpwrpy::after{background-position:0px 0px;}
.atm_cft73o_1ixb3zs.atm_cft73o_1ixb3zs::before,.atm_cft73o_1ixb3zs.atm_cft73o_1ixb3zs::after{background-image:conic-gradient(
      from 0deg at 50% 50%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 8%,
      var(--animated-badge-primary, var(--fabric-color-seaweed-70)) 20%,
      var(--animated-badge-primary, var(--fabric-color-seaweed-70)) 80%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 92%,
      var(--animated-badge-highlight, var(--fabric-color-seaweed-20)) 100%
    );}
.atm_5dmy31_1i1uaeb::before,.atm_5dmy31_1i1uaeb::after{animation:rotate var(--animated-badge-speed, 1.8s) linear infinite;}
.atm_1isonqh_10mzh2i::before{filter:blur(var(--animated-badge-blur, 16px));}
.atm_wq_kb7nvz{z-index:1;}
.atm_e2_qslrf5{height:22px;}
.atm_2d_1svnf5h.atm_2d_1svnf5h{background-color:var(--animated-badge-bg, var(--fabric-color-seaweed-50));}
.atm_r3_1h6ojuz{text-align:center;}
.atm_vv_1q9ccgz{white-space:nowrap;}
.atm_20_10mzh2i{backdrop-filter:blur(var(--animated-badge-blur, 16px));}
.atm_l8_f67zm9{padding:0 7px;}
.atm_9s_116y0ak{display:inline-flex;}
.atm_l8_hooyhf{padding:2px 8px;}
